<template>
  <div class="job-opportunities">
    <headline />
    <div class="img">
      <img src="./img/u3095.png" alt />
    </div>
    <div class="head">
      <div>
        <img src="./img/u3101.png" alt />
        <span>
          <router-link to="/">首页</router-link>
        </span>
        <span>/</span>
        <span>工作机会</span>
      </div>
      <!-- <div>
        <img src="./img/u3129.png" alt />
      </div>-->
    </div>
    <div class="work">
      <div class="sale">
        <div>
          <div>
            <img class="work-img" src="./img/u3123.png" alt />
            <p class="title-font">销售工程师</p>
          </div>
          <div class="recruitment-content">
            <img class="work-img" src="./img/u3123.png" alt />
            <p>发布日期：2020/03/25</p>
          </div>
          <div>
            <img class="work-img" src="./img/u3123.png" alt />
            <p>
              <span>招聘人数：10</span>
              <span>工作地点：北京</span>
            </p>
          </div>
        </div>
      </div>
      <div class="wack">
        <div>
          <div>
            <img src="./img/u3123.png" alt />
            <p class="title-font">职位描述</p>
          </div>
          <div class="recruitment-content pigment">
            <img class="work-img" src="./img/u3123.png" alt />
            <div>
              <p>1、负责公司软件产品全国范围的销售；</p>
              <p>2、定期拜访客户，协调好客户的关系，积极拓展市场；</p>
              <p>
                3、为人乐观开朗，善于与人沟通，责任心强，既能团队合作，又有较强独立性。
              </p>
              <p>4、对销售充满激情。</p>
            </div>
          </div>
        </div>
      </div>
      <div class="wack">
        <div>
          <div>
            <img src="./img/u3125.png" alt />
            <p class="title-font">职位要求</p>
          </div>
          <div class="recruitment-content pigment">
            <img class="work-img" src="./img/u3123.png" alt />
            <div>
              <p>1、精通软件项目销售的过程、做法和规则</p>
              <p>2、了解竞争对手的产品和销售策略</p>
              <p>3、具备良好的演讲、沟通、说服能力，赢得客户的信任</p>
              <p>4、客观评估客户的倾向性，准确把握和客户的关系</p>
              <p>5、熟悉招投标过程，了解合同法，了解财务知识</p>
              <p>6、项目销售过程中的存在的风险及风险防范</p>
              <p>7、精通本人负责的产品线的业务知识</p>
              <p>8、有项目销售经验者优先。</p>
            </div>
          </div>
        </div>
      </div>
      <div class="wack">
        <div>
          <div>
            <img src="./img/u3127.png" alt />
            <p class="title-font">联系方式</p>
          </div>
          <div class="recruitment-content pigment">
            <img class="work-img" src="./img/u3123.png" alt />
            <div>
              <p>电话：010-61734973</p>
              <p>传真：010-61734543</p>
              <p>邮箱：ym-comprehensive@328ym.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <foot />
  </div>
</template>

<script>
import headline from "@/components/headline/headline";
import foot from "@/components/foot/foot";

export default {
  data() {
    return {};
  },
  components: {
    headline,
    foot
  }
};
</script>

<style lang="less" scoped>
.job-opportunities {
  background: rgba(239, 242, 247, 1);
}
.img {
  img {
    width: 100%;
  }
}
.head {
  height: 0.8rem;
  border-bottom: 0.01rem solid rgba(221, 221, 221, 1);
  margin: 0 1.6rem;
  div {
    padding-top: 0.4rem;
    img {
      margin-right: 0.12rem;
    }
    span {
      font-size: 0.2rem;
      font-weight: 600;
      color: rgba(34, 34, 34, 1);
      margin-right: 0.1rem;
      a {
        color: rgba(34, 34, 34, 1);
      }
    }
  }
}
.work {
  margin-bottom: 0.8rem;
}
.title-font {
  font-size: 0.3rem;
  font-weight: 600;
  color: rgba(34, 34, 34, 1);
  margin-bottom: 0.1rem;
}
.recruitment-content {
  div {
    display: inline-block;
    p {
      font-size: 0.24rem;
      font-weight: 400;
    }
  }
}
.pigment {
  p {
    color: rgba(68, 68, 68, 1);
    margin-bottom: 0.1rem;
  }
}
.sale {
  margin: 0 1.6rem;
  padding: 0.4rem 0 0.2rem;
  border-bottom: 0.01rem solid rgba(221, 221, 221, 1);
  & > div {
    padding-left: 0.53rem;
    & > div {
      & > p,
      & > img {
        display: inline-block;
      }
      img {
        margin-right: 0.2rem;
        vertical-align: sub;
      }
    }
    & > div:nth-child(2) {
      & > p {
        color: rgba(102, 102, 102, 1);
        margin-bottom: 0.2rem;
        font-size: 0.2rem;
      }
    }
    & > div:nth-child(3) {
      p {
        font-size: 0.2rem;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        span {
          margin-right: 1.64rem;
        }
      }
    }
  }
  .work-img {
    visibility: hidden;
  }
}
.wack {
  margin: 0 1.6rem;
  padding: 0.2rem 0;
  & > div {
    padding-left: 0.53rem;
    & > div {
      & > p,
      & > img {
        display: inline-block;
      }
      img {
        margin-right: 0.2rem;
        vertical-align: sub;
      }
    }
    & > div:nth-child(2) {
      & > p {
        color: rgba(102, 102, 102, 1);
        margin-bottom: 0.2rem;
        font-size: 0.14rem;
      }
    }
    & > div:nth-child(3) {
      p {
        font-size: 0.2rem;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        span {
          margin-right: 1.64rem;
        }
      }
    }
  }
  .work-img {
    visibility: hidden;
  }
}

@media screen and (max-width: 900px) {
  .head {
    & > div {
      padding-top: 0.2rem !important;
      img {
        width: 0.12rem;
      }
    }
  }
  .work {
    & > div > div img {
      width: 0.2rem !important;
      vertical-align: middle !important;
    }
  }
}
</style>
